export const REFER_AND_EARN_BANNER_DISMISSED_HINT_KEY = 'REFER_AND_EARN_BANNER_DISMISSED'
export const REFER_AND_EARN_LINK_COPIED_HINT_KEY = 'REFER_AND_EARN_LINK_COPIED'
